import RequiredTitle from "elements/RequiredTitle";
import { Input } from "reactstrap";

const TitleInput = ({ text }) => {
  return <h5>{text}</h5>;
};

// Input group for acquiring information about a company.
const CompanyInfoGroup = ({ values, onChange }) => {
  return (
    <>
      <h3 className="text-dark mb-0">Company Information</h3>
      <p className="small">
        We&apos;ll use this information to tailor settings specific to your
        cloud.
      </p>
      <TitleInput text="Company Name" />
      <Input
        className="mb-4"
        placeholder="Name"
        name="CompanyName"
        value={values.CompanyName}
        onChange={onChange}
      />
      <TitleInput text="Website" />
      <Input
        placeholder="Website"
        name="CompanyWebsite"
        value={values.CompanyWebsite}
        onChange={onChange}
      />
      <hr className="my-4" />
      <h3 className="text-dark mb-0">Billing Information</h3>
      <p className="small">
        Who and where we should reach out regarding billing.
      </p>
      <TitleInput text="Billing Address" />
      <Input
        className="mb-2"
        placeholder="Street Address"
        name="BillingAddress"
        value={values.BillingAddress}
        onChange={onChange}
      />
      <Input
        className="mb-2"
        placeholder="Suite / Unit"
        name="BillingAddress2"
        value={values.BillingAddress2}
        onChange={onChange}
      />
      <Input
        className="mb-2"
        placeholder="City"
        name="BillingCity"
        value={values.BillingCity}
        onChange={onChange}
      />
      <Input
        className="mb-2"
        placeholder="State"
        name="BillingState"
        value={values.BillingState}
        onChange={onChange}
      />
      <Input
        className="mb-2"
        placeholder="Zip"
        name="BillingZip"
        value={values.BillingZip}
        onChange={onChange}
      />
      <div className="mt-4">
        <RequiredTitle title="Billing Contact Name" />
        <Input
          className="mb-4"
          placeholder="Name"
          name="BillingContactName"
          value={values.BillingContactName}
          onChange={onChange}
        />
      </div>
      <RequiredTitle title="Billing Contact Email" />
      <Input
        placeholder="Email"
        name="BillingContactEmail"
        value={values.BillingContactEmail}
        onChange={onChange}
      />
    </>
  );
};

export default CompanyInfoGroup;
